import React from 'react';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { AppScreen } from '../../components/AppScreen';
import { FaceEnrollmentCamera } from '../../components/FaceEnrollmentCamera';
import { PermissionGuard } from '../../components/PermissionGuard';
import { ScreenHeader } from '../../components/ScreenHeader';
import { PERMISSIONS } from '../../constants/permissions';
import type { RootStackParamList } from '../../constants/routes';
import { UnauthorizedScreen } from '../system/UnauthorizedScreen';

type Props = NativeStackScreenProps<RootStackParamList, 'FaceEnrollmentCamera'>;

/**
 * Route wrapper around FaceEnrollmentCamera.
 * Captured image URIs are returned through the onCaptured callback only and
 * must not be placed in navigation params.
 */
export function FaceEnrollmentCameraScreen({ navigation, route }: Props) {
  return (
    <PermissionGuard
      permission={PERMISSIONS.FACE_REGISTER}
      fallback={<UnauthorizedScreen />}
    >
      <AppScreen scroll>
        <ScreenHeader
          title="Face enrollment"
          onBack={navigation.goBack}
        />
        <FaceEnrollmentCamera
          guidanceLabel={route.params.guidanceLabel}
          autoLaunch
          onCaptured={() => {
            // Callers that need a URI should embed FaceEnrollmentCamera directly
            // so the temporary file never enters navigation state.
            navigation.goBack();
          }}
          onCancel={() => navigation.goBack()}
        />
      </AppScreen>
    </PermissionGuard>
  );
}
